export class WebSocketMappings {
	public static setAccountPayload(userId: number, accountId: number) {
		if (isNaN(userId) || isNaN(accountId)) {
			throw new Error(
				`Invalid data passed in for setAccountPayload: userId = ${userId}, accountId = ${accountId}.`
			);
		}

		return {
			action: 'setAccount',
			userId,
			accountId,
		};
	}
}
